import { call, put, takeEvery } from 'redux-saga/effects'
import { fetchCurrencies } from 'services/api/currencies'

import { fetchError, fetchSuccess } from './actions'
import { FETCH_CURRENCIES } from './actionTypes'

const fetchSaga = function* () {
  performance.mark('CurrenciesSagaFetch:start')
  const { error, response } = yield call(fetchCurrencies, 'custodial')
  performance.mark('CurrenciesSagaFetch:end')
  performance.measure('CurrenciesSagaFetch', 'CurrenciesSagaFetch:start', 'CurrenciesSagaFetch:end')
  if (error) {
    yield put(fetchError(error))
    return
  }

  yield put(fetchSuccess(response.currencies))
}

const currenciesSagas = function* () {
  yield takeEvery(FETCH_CURRENCIES, fetchSaga)
}

export default currenciesSagas
